function celula(valor) {
  if (valor == null) return null;
  const texto = String(valor).trim();
  if (!texto || texto === 'undefined') return null;
  return texto;
}

function coordenada(valor, minimo, maximo) {
  if (valor == null || valor === '') return { valor: null, invalida: false };
  if (typeof valor === 'number') {
    if (!Number.isFinite(valor) || valor < minimo || valor > maximo) return { valor: null, invalida: true };
    return { valor, invalida: false };
  }
  const texto = String(valor).trim();
  if (!texto) return { valor: null, invalida: false };
  const numero = Number(texto.replace(/\s/g, '').replace(',', '.'));
  if (!Number.isFinite(numero) || numero < minimo || numero > maximo) return { valor: null, invalida: true };
  return { valor: numero, invalida: false };
}

function montarEndereco(rua, numero, bairro) {
  const logradouro = [rua, numero].filter(Boolean).join(', ');
  if (logradouro && bairro) return `${logradouro} - ${bairro}`;
  return logradouro || bairro || null;
}

export function parsePlanilhaPostes(rows) {
  const linhas = Array.isArray(rows) ? rows : [];
  const postes = [];
  const ignoradas = [];
  const semCoordenada = [];
  linhas.forEach((item, index) => {
    if (index === 0) return;
    const linha = index + 1;
    if (!item || item.length === 0) return;
    const codigo = celula(item[2]);
    if (!codigo) {
      ignoradas.push({ linha, motivo: 'Sem código do poste' });
      return;
    }
    const municipio = celula(item[0]);
    const rua = celula(item[3]);
    const numero = celula(item[4]);
    const bairro = celula(item[5]);
    const latitude = coordenada(item[6], -90, 90);
    const longitude = coordenada(item[7], -180, 180);
    const semPonto = latitude.valor == null || longitude.valor == null;
    if (semPonto) semCoordenada.push({ linha, codigo });
    postes.push({
      municipio,
      codigo,
      numeroPoste: codigo,
      endereco: montarEndereco(rua, numero, bairro),
      rua,
      numero,
      bairro,
      latitude: semPonto ? null : latitude.valor,
      longitude: semPonto ? null : longitude.valor,
      fotoInicio: false,
      fotoFim: false,
      analiseRisco: false,
      fotoRegistro: false,
    });
  });
  return { postes, ignoradas, semCoordenada };
}
